<script setup lang="ts">
import DashboardBadge from '@/components/badges/DashboardBadge.vue';

export interface Props {
  isActive?: boolean;
  count?: number;
}
const props = withDefaults(defineProps<Props>(), {
  isActive: false,
  count: 0,
});
</script>

<template>
  <v-btn
    rounded
    variant="outlined"
    :ripple="false"
    :class="$style.dashboardFiltersBtn"
    data-testid="dashboardFiltersBtn"
    :color="$style.color"
  >
    <span :class="$style.prepend">
      <v-icon
        v-if="!props.isActive"
        :class="$style.icon"
        icon="mdi-filter-variant"
      >
      </v-icon>
      <DashboardBadge
        v-else
        :class="$style.badge"
        type="filters"
        :content="props.count"
      />
    </span>
    Filters
  </v-btn>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

:export {
  color: colors.$color-brand-800;
}

.dashboardFiltersBtn {
  text-transform: none;
  letter-spacing: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 1.4;
  transition-property: none;
  height: 48px !important;

  :global {
    .v-btn__overlay {
      display: none;
    }
  }

  &:hover {
    background-color: colors.$color-brand-50;
  }

  &:active {
    background-color: colors.$color-brand-100;
  }
}
  .prepend {
    margin-right: 6px;
    min-width: 27px;
    text-align: left;
  }
    .icon {
      font-size: 24px;
    }
    .badge {
      margin-left: -11px;
      margin-right: -5px;
    }
</style>
